export default "__VITE_ASSET__CfrcKvHT__"